import React from "react";
import { Grid } from "@material-ui/core";

import "../styles/index.scss";

function Section({ children, ...props }) {
  return (
    <Grid
      container
      width="100vw"
      display="flex"
      alignItems="center"
      justifyContent="center"
      {...props}
    >
      <Grid item lg={8} md={9} xs={10}>
        {children}
      </Grid>
    </Grid>
  );
}

export default Section;
